<template>
  <div
    :class="[
      $style.cardWrapper,
      isSelected && $style.isSelected
    ]"
    class="px-2 px-sm-4"
  >
    <div
      :class="[$style.leftContentWrapper]"
      @mouseenter="handleMouseEnter"
      @mouseleave="handleMouseLeave"
      @click="handleMouseEnter"
    >
      <div
        :class="$style.avatarWrapper"
        class="pr-2"
      >
        <BaseAvatar
          :size="65"
          :url="require('@/assets/images/avatar-gray.svg')"
          is-lazy
          :is-hover="isHover"
        />
      </div>
      <div :class="$style.nameWrapper">
        {{ $t('none') }}
        <div :class="$style.captionWrapper">
          <slot name="caption" />
        </div>
      </div>
    </div>
    <div
      v-if="$slots['right']"
      :class="[$style.buttonWrapper]"
    >
      <slot name="right" />
    </div>
  </div>
</template>

<script>
import BaseAvatar from '@/components/Atoms/BaseAvatar'

export default {
  name: 'BaseAthleteNoneCard',
  components: { BaseAvatar },
  inheritAttrs: false,
  props: {
    isSelected: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isHover: null,
    }
  },
  methods: {
    handleClick() {
      this.$emit('click')
    },
    handleMouseEnter() {
      this.isHover = true
    },
    handleMouseLeave() {
      this.isHover = false
    },
  },
}
</script>

<style module lang="scss">
  @import "../../assets/scss/variables";

  .cardWrapper {
    padding: .5rem;
    display: flex;
    justify-content: space-between;
    background: $color-white;
    transition: all .3s ease-in-out;
    border-bottom: 1px solid $color-windswept-beach;

    &:hover {
      background: $color-bleached-silk;
    }
  }

  .isSelected {
    background: lighten($color-alley, 15);

    &:hover {
      background: lighten($color-alley, 9);
    }
  }

  .leftContentWrapper {
    display: flex;
    flex-direction: row;
  }

  .avatarWrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .nameWrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    flex: 1;
    text-align: left;
    font-size: $font-size-small;
  }

  .captionWrapper {
    font-size: $font-size-tiny;
  }

  .buttonWrapper {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .contentWrapper {
    display: flex !important;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 0 !important;
    height: 100%;
    overflow: hidden !important;
  }
</style>
